import { useQuery } from '@tanstack/react-query'

import { queryKeys } from '@/constants/queryKeys'
import { CategoryModel } from '@/http/models'

import { unwrap } from '../unwrap'

export const useCategories = () =>
  useQuery({ queryKey: queryKeys.categories, queryFn: () => unwrap(CategoryModel.getList()), staleTime: Infinity })
